import { ArrowClockwise20Regular, Box20Regular, ErrorCircle20Regular } from '@fluentui/react-icons';
import { Button, Spinner } from '@fluentui/react-components';

export function LoadingState({ label = 'Loading records' }: { label?: string }) {
  return (
    <div className="fc-state-panel" role="status" aria-live="polite">
      <div>
        <Spinner label={label} labelPosition="below" />
        <div aria-hidden="true" style={{ display: 'grid', gap: 10, marginTop: 24 }}>
          <div className="fc-skeleton-line" />
          <div className="fc-skeleton-line" />
          <div className="fc-skeleton-line" />
        </div>
      </div>
    </div>
  );
}

export function EmptyState({
  detail,
  title = 'No matching records',
}: {
  detail: string;
  title?: string;
}) {
  return (
    <div className="fc-state-panel">
      <div>
        <Box20Regular aria-hidden="true" fontSize={28} />
        <h2>{title}</h2>
        <p>{detail}</p>
      </div>
    </div>
  );
}

export function ErrorState({
  detail = 'The records could not be loaded. Your financial data was not replaced with a zero value.',
  onRetry,
  title = 'Could not load records',
}: {
  detail?: string;
  onRetry: () => void;
  title?: string;
}) {
  return (
    <div className="fc-state-panel" role="alert">
      <div>
        <ErrorCircle20Regular aria-hidden="true" fontSize={28} />
        <h2>{title}</h2>
        <p>{detail}</p>
        <Button icon={<ArrowClockwise20Regular />} onClick={onRetry} style={{ marginTop: 18 }}>
          Try again
        </Button>
      </div>
    </div>
  );
}
